import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizacionesService } from '@app/_services/organizaciones.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService } from '@app/_services/menu.service';
import { PublicacionesService } from '@app/_services/publicaciones.service';
import { IdiomasService } from '@app/_services/idiomas.service';
import { Ente } from '@app/_models/ente';
import { Categoria } from '@app/_models/categoria';
import { Idioma } from '@app/_models/idioma';
import { Noticia, NoticiaTraduccion } from '@app/_models/noticia';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import {
  AlertService,
  DepartamentosService,
  UsuariosService,
} from '@app/_services';
import { Recinto, RecintoTrad, Sala, SalaTrad } from '@app/_models/recinto';
import { RecintosService } from '@app/_services/recintos.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Usuario } from '@app/_models';

@Component({
  selector: 'app-salas-crear',
  templateUrl: './salas-crear.component.html',
})
export class SalasCrearComponent implements OnInit {
  //Listas

  listaIdiomas: Idioma[] = [];
  listaIdiomasTotales: Idioma[] = [];
  listaTraducciones: Idioma[] = [];
  //Permisos Sala
  listaAdminsSala: Usuario[] = []; // Pueden reservar directo
  listaUsuariosSala: Usuario[] = []; // Pueden reservar pero necesitan confirmacion
  //Traducciones
  listaTraduccionesEnviar: SalaTrad[] = [];
  //Data
  nombreSala: string = '';
  descripcionSala: string = '';
  superficieSala: number;
  aforo: number;
  imagenB64: string = '';
  selectedIdioma: Idioma;
  salaActiva: boolean = true;
  salaPrivada: boolean = true;
  salaHasTarifa: boolean = true;
  salaMustConfirmar: boolean = true;
  correosEnviarReserva: string;
  latitud: string = '';
  longitud: string = '';
  numDiasReserva: number;
  horasReservableDia:number;
  mySala: Sala = new Sala();
  idRecinto: number = 0;
  filePath: string;

  lang;
  private translate: TranslateService;
  idOrg: string;

  constructor(
    private recintosService: RecintosService,
    private idiomaService: IdiomasService,
    private organizacionService: OrganizacionesService,
    private usuariosService: UsuariosService,
    private menuService: MenuService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    translate: TranslateService,
    private translateService: TranslateService
  ) {
    this.translate = translate;
    this.menuService.titulo = this.translate.instant('recintos.cabecera');
  }

  ngOnInit(): void {
    this.lang = this.translateService.getDefaultLang();
    this.idOrg = this.route.snapshot.params['idorg'];
    this.idRecinto = this.route.snapshot.params['idrecinto'];
    //Load Langs
    this.idiomaService.GetAll().subscribe((result) => {
      this.listaIdiomasTotales = result.data;
      console.log('Cargados idiomas = ' + this.listaIdiomasTotales.length);
      this.listaIdiomasTotales.forEach((x) => {
        const trad = new SalaTrad();
        trad.filled = false;
        trad.idIdioma = x.codigo;
        trad.nombreIdioma = x.nombre;
        this.listaTraduccionesEnviar.push(trad);
      });
    });

    this.idiomaService.getIdiomasFromEnte(this.idOrg).subscribe((result) => {
      this.listaIdiomas = result.data;
      if (this.listaIdiomas.length > 0)
        this.selectedIdioma = this.listaIdiomas[0];
    });

  }

  btnCrearSala() {
    console.log('Creando Sala');
    //Validación de los datos
    if (this.listaTraducciones.length <= 0) {
      this.alertService.info(
        this.translateService.instant('publicaciones.errortrads')
      );
      return;
    }
    if (this.filePath == null) {
      this.alertService.info(
        this.translateService.instant('publicaciones.validaciondatos')
      );
      return;
    }

    //AutoCompletado de Idiomas
    //seleccionado
    let seleccionado: SalaTrad = new SalaTrad();
    let encontrado: boolean = false;
    this.listaTraduccionesEnviar.forEach((trad) => {
      if (trad.filled && !encontrado) {
        seleccionado = trad;
        encontrado = true;
        return;
      }
    });
    //Fill UnFilled
    this.listaTraduccionesEnviar.forEach((trad) => {
      if (!trad.filled) {
        trad.nombre = seleccionado.nombre;
        trad.descripcion = seleccionado.descripcion;
      }
    });

    console.log(this.listaTraduccionesEnviar);
    //Subir Foto  y EnviarNoticia
    this.mySala.idOrg = this.idOrg;
    this.mySala.idRecinto = this.idRecinto;
    this.mySala.activo = this.salaActiva;
    this.mySala.nombre = this.nombreSala;
    this.mySala.superficie = this.superficieSala;
    this.mySala.descripcion = this.descripcionSala;
    this.mySala.numDiasReserva = this.numDiasReserva;
    this.mySala.horasReservablesDia = this.horasReservableDia;
    this.mySala.aforo = this.aforo;
    this.mySala.isPrivado = this.salaPrivada;
    this.mySala.tarifaActiva = this.salaHasTarifa;
    this.mySala.confirmarReserva = this.salaMustConfirmar;
    this.mySala.emails = this.correosEnviarReserva;
    this.mySala.latitud = this.latitud;
    this.mySala.longitud = this.longitud;
    this.mySala.listaAdminsSala = this.listaAdminsSala;
    this.mySala.listaUsuariosSala = this.listaUsuariosSala;
    this.mySala.listaTraducciones = this.listaTraduccionesEnviar;
    this.mySala.imagen = this.filePath.split(',')[1]; //Borramos cabecera data: base64
    console.log('Evinado recinto');
    this.recintosService.crearSala(this.mySala).subscribe((result) => {
      if (!result.error) {
        this.alertService.success(
          this.translateService.instant('recintos.success')
        );
        this.router.navigate(['salas']);
      } else {
        console.log('Error enviando traducciones publicacion');
        this.alertService.error(
          this.translateService.instant('recintos.error')
        );
        return;
      }
    });
  }

  btnAddTraduccion() {
    console.log('Comprobando datos');
    if (
      this.selectedIdioma == null ||
      this.nombreSala.length <= 0 ||
      this.descripcionSala.length <= 0
    ) {
      if (this.listaTraducciones.length <= 0) {
        this.alertService.info(
          this.translateService.instant('publicaciones.validacion')
        );
        return;
      }
    }
    console.log('Datos validados --->');
    if (!this.listaTraducciones.includes(this.selectedIdioma)) {
      this.listaTraducciones.push(this.selectedIdioma);

      this.listaTraduccionesEnviar.map((x) => {
        if (x.idIdioma == this.selectedIdioma.codigo) {
          x.filled = true;
          x.nombre = this.nombreSala;
          x.descripcion = this.descripcionSala;
        }
      });
    } else {
      console.log('Idioma ya añadido');
    }

    console.log(this.listaTraduccionesEnviar);
  }

  btnDeleteTraduccion(idioma: Idioma) {
    console.log(idioma);
    this.listaTraducciones = this.listaTraducciones.filter(
      (x) => x.codigo != idioma.codigo
    );

    this.listaTraduccionesEnviar.map((x) =>
      x.idIdioma == idioma.codigo ? (x.filled = false) : console.log()
    );

    console.log(this.listaTraduccionesEnviar);
  }

  getUsuariosSeleccionados(listaUsuarios) {
    console.log('Llegan Usuarios');
    console.log(listaUsuarios);
    this.listaUsuariosSala = listaUsuarios;
  }

  getUsuariosAdmin(users){
    this.listaAdminsSala=users;
    console.log(users);
  }

  getUsuariosSala(users){
    this.listaUsuariosSala=users;
    console.log(users);
  }

  //Imagen

  imagePreview(e) {
    const file = (e.target as HTMLInputElement).files[0];
    const reader = new FileReader();
    reader.onload = () => {
      this.filePath = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  btnCancelar() {
    this.router.navigate(['salas']);
  }
}
